<template>
  <div :id="id" class="szuro-badgek">
    <transition-group name="list-complete">
      <!-- <span
        v-for="badge in badgekOrdered"
        :key="badge.Id + badge.szuro.propNev"
        class="list-complete-item filterbadge"
      > -->
      <a
        v-for="badge in badgekOrdered"
        :key="badge.Id + badge.szuro.propNev"
        class="list-complete-item filterbadge mb-10"
        :class="[
          { active: badge.selected },
          badge.Id == 'status_cleaned'
            ? 'cleaned ' + badge.szuro.class
            : badge.szuro.class,
        ]"
        v-on:click="SelectBadge(badge)"
        href="javascript:;"
        :id="badge.Id + badge.szuro.propNev"
      >
        <span v-if="badge.szuro.i18n" v-html="$t(badge.Nev)"> </span>
        <span v-else v-html="badge.Nev"> </span>
        <span class="badge badge-pill badge-default up">{{ badge.count }}</span
        ><i v-if="badge.selected" class="fa fa-times"></i>
      </a>

      <!-- <b-tooltip
          :target="badge.Id + badge.szuro.propNev"
          triggers="hover"
          :delay="{ show: 500, hide: 100 }"
          :container="'#' + id"
        >
          {{ badge.szuro.tooltip }}
        </b-tooltip> -->
      <!-- </span> -->
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'szuro-badgek',
  data() {
    return {
      id: 'szuroBadgek-' + +new Date(),
    };
  },
  mounted() {},
  created() {},
  methods: {
    SelectBadge(badge, removeKey) {
      let key = badge.szuro.propNev + badge.Id;
      let initialLength = this.selected.length;
      let selectedBadges = this.selected.slice();
      let ujBadgeIndex = selectedBadges.findIndex(s => s.key == key);
      if (ujBadgeIndex > -1) {
        selectedBadges.splice(ujBadgeIndex, 1);
      } else {
        selectedBadges.push({ key: key, value: badge });
      }
      if (removeKey) {
        selectedBadges = selectedBadges.filter(s => s.key != removeKey);
      }

      this.$emit('update:selected', selectedBadges);
    },
    IsSelected(badge) {
      return this.selected.some(
        s =>
          s.value.szuro.propNev + s.value.Id == badge.szuro.propNev + badge.Id
      );
    },

    SortSzuroBadge(a, b) {
      let diffSelected = parseInt(b.selected) - parseInt(a.selected);
      if (diffSelected != 0) {
        return diffSelected;
      }
      let diffOrder = parseInt(a.szuro.order) - parseInt(b.szuro.order);
      if (diffOrder != 0) {
        return diffOrder;
      }
      return b.count - a.count;
    },
  },
  computed: {
    badgekOrdered() {
      let selected = this.selected;
      let badgek = this.badgek.map(m => {
        let badge = { ...m };
        badge.selected = this.IsSelected(badge) ? 1 : 0;
        return badge;
      });
      badgek = badgek.filter(f => f.szuro.mapObj == this.mapObj);
      badgek.sort(this.SortSzuroBadge);
      return badgek;
    },
  },
  watch: {},
  props: {
    selected: {
      type: Array,
      required: true,
    },
    badgek: {
      type: Array,
      required: true,
    },
    mapObj: {
      type: String,
      required: true,
    },
  },
};
</script>
